import ROUTES from '../../constants/routes';
import qualityEvents from '../../services/quality-events';
import os from '../../utils/os';
import {
    APPSTORE_URL,
    PROMOTE_APP_ALLOWED_ROUTES,
    PROMOTE_APP_NAME_V2,
    PROMOTE_APP_RESHOW_DATE,
    PROMOTE_APP_TRACK_EVENTS,
    PROMOTE_APP_TRACK_NAME
} from './promote-app.constants';

export const formPlayMarketURL = (uId?: string) => {
    const baseUrl = 'https://play.google.com/store/apps/details?id=com.lmp.buyer&referrer=utm_source%3Deduki-banner';

    if (uId) {
        return `${baseUrl}%26uid%3D${uId}`;
    }

    return baseUrl;
};

const isReshowDateCome = () => {
    const reshowDateIsoStr = window.storage.getItem(PROMOTE_APP_RESHOW_DATE);

    if (!reshowDateIsoStr) {
        return true;
    }

    const reshowDate = new Date(reshowDateIsoStr);
    const currentDate = new Date();
    const utcCurrentDate = new Date(currentDate.toUTCString());

    return utcCurrentDate > reshowDate;
};

const isAllowedOnPage = () => {
    return (
        PROMOTE_APP_ALLOWED_ROUTES.some((route) => window.location.pathname.includes(route)) ||
        window.location.pathname.endsWith(ROUTES.HOME.path)
    );
};

const isConsentBannerClosed = window.storage.getItem('uc_user_interaction') === 'true';

export const isAppPromotionAllowed = () =>
    window.innerWidth < 991 && isAllowedOnPage() && isReshowDateCome() && isConsentBannerClosed;

export const trackAppPromotionEvent = async (type: PROMOTE_APP_TRACK_EVENTS) => {
    const extraTrackParams = {
        promoteAppTrackName: PROMOTE_APP_TRACK_NAME,
        promotionName: PROMOTE_APP_NAME_V2
    };

    await qualityEvents.track({
        type: `${PROMOTE_APP_TRACK_NAME}-${type}`,
        extra: JSON.stringify(extraTrackParams)
    });
};

const setReshowAppPromotionDate = (reshowInDays: number) => {
    const currentDate = new Date();
    const utcDate = new Date(currentDate.toUTCString());

    utcDate.setUTCDate(utcDate.getUTCDate() + reshowInDays);
    const reshowBannerDate = utcDate.toISOString();

    window.storage.setItem(PROMOTE_APP_RESHOW_DATE, reshowBannerDate);
};

export const onCloseAppPromotion = (closeCallback: () => void, disableTracking?: boolean) => {
    if (disableTracking) {
        setReshowAppPromotionDate(7);
        closeCallback();
    } else {
        trackAppPromotionEvent(PROMOTE_APP_TRACK_EVENTS.CLOSE_CLICK).finally(() => {
            setReshowAppPromotionDate(7);
            closeCallback();
        });
    }
};

export const onDownload = (userId?: string) => {
    trackAppPromotionEvent(PROMOTE_APP_TRACK_EVENTS.DOWNLOAD_CLICK).finally(() => {
        window.location.href = os?.isIOS || os?.isMacOS ? APPSTORE_URL : formPlayMarketURL(userId);
    });
};
